
import {Product, ProductCompositionRow} from "@/models/base";
import { ProductCompositionEditRowState } from "@/utils/product-composition-edit-row-state";
import Vue from "vue";
import AppProductEditRow from "./ProductEditCompositionEditRow.vue";
import AppProductsTable from "./ProductEditCompositionTable.vue";
import { CustomTranslation } from "@/utils/custom-translation";
import {ProductService} from "@/services";

export default Vue.extend({
	data() {
		return {
			editRow: new ProductCompositionRow(),
			editRowState: new ProductCompositionEditRowState()
		};
	},
	props: {
		selectedRow: Object as () => ProductCompositionRow,
		vatRegime: Number,
		discount: Number,
		items: Array as () => ProductCompositionRow[],
		priceCategory: Number,
		lng: {
			type: String,
			default: "nl-be"
		},
	},
	watch: {
		"selectedRow.UnitBuyPrice"(){
			this.editRowState.unitBuyPrice = this.selectedRow?.UnitBuyPrice;
		}
	},
	methods: {
		async onAddRow(row: { row: ProductCompositionRow, product?: Product, skipNewRow?: Boolean }) {
			let scroll = this.items.indexOf(row.row) == -1;
			let toAddRows: ProductCompositionRow[] = [];
			this.$emit("add", row);

			row.row.ProductID = row.product?.ID || 0;
			row.row.ReferencedProductID = null;

			if (row.row.ProductSku != "") {
				let product = await ProductService.findBySku(row.row.ProductSku);
				row.row.ReferencedProductID = product.ID || null;
			}
			if(row.product){
				row.row.Product = row.product;
			}
			let i = this.items.indexOf(row.row);
			if (i == -1) {
				toAddRows.push(row.row);
				toAddRows.push(...this.createCompositionRows(row.row));
				this.items?.push(...toAddRows);
			}else{
				this.items.splice(i + 1, 0, ...this.createCompositionRows(row.row));
			}
			if (!row.skipNewRow) {
				this.editRow = new ProductCompositionRow();
				this.editRow.Discount = this.discount;

				if (scroll) {
					setTimeout(() => {
						this.scrollBottom();
					}, 200);
				}
			}
		},
		onMultipleProductsSelected(products: Product[]) {
			for (let product of products) {
				let row = new ProductCompositionRow();
				row.ProductSku = product.Sku || "";
				row.Product = product;
				row.ReferencedProductID = product.ID;
				if (product.Unit != null) {
					row.UnitName = product.Unit.Name.getTranslation(this.lng);
				}
				row.ProductDescription = product.TranslatedName.getTranslation(this.lng);
				row.TranslatedDescription = new CustomTranslation(product.TranslatedName.getJSON());

				if (this.priceCategory != 0) {
					let price = (product as any)["SellPrice" + this.priceCategory];
					row.UnitPrice = parseFloat(price);
				} else {
					row.UnitPrice = product.SellPrice1;
				}

				this.items.push(row);
			}
		},
		insertRowBefore() {
			let index = this.items.findIndex((r) => this.selectedRow == r);

			let row = new ProductCompositionRow();
			row.Amount = 1;
			row.Duration = 0;
			row.ProductSku = "";

			if (index == -1) {
				this.items.push(row);
			} else if (index == 0) {
				this.items.unshift(row);
			} else {
				this.items.splice(index, 0, row);
			}

			this.$emit("select", row);
			this.$emit("update", this.items);
		},
		onEdit(row: ProductCompositionRow) {
			if (row == this.editRow) {
				this.editRow = new ProductCompositionRow();
				return;
			}
			this.editRow = row || new ProductCompositionRow();
		},
		onRowSelect(row: ProductCompositionRow) {
			this.$emit("select", row);
		},
		onRemove(row: ProductCompositionRow) {
			this.$emit("remove", row);
		},
		scrollBottom() {
			var container = this.$el.querySelector("#products-table > tbody");

			if (container)
				container.scrollTop = (container.scrollHeight + 29);
		},
		searchProducts() {
			this.$emit("search-products");
		},
		onKeyDown(e: KeyboardEvent) {

			if (e.keyCode == 115) {
				this.$emit("subtotal");
			}

			if ((e.target as HTMLTextAreaElement).className.indexOf("w-input") >= 0 ||
				(e.target as HTMLTextAreaElement).className.indexOf("w-textarea") >= 0 ||
				(e.target as HTMLTextAreaElement).className.indexOf("ql-editor") >= 0) {
				return;
			}

			let m = document.getElementsByClassName("modal");
			if (m.length > 0) {
				if (m[0].querySelector(".modal") !== null) return;
			}

			if (e.keyCode == 46 || e.keyCode == 8) {
				this.$emit("remove", this.selectedRow);
			}

			return;
		},
		createCompositionRows(row: ProductCompositionRow): ProductCompositionRow[]{
			if (!row.Product) return [];
			let toAddRows: ProductCompositionRow[] = [];
			let qty = row.Amount;
			for (let compositionRow of row.Product.Composition) {
				let row = new ProductCompositionRow();
				row.Vat = compositionRow.Vat;
				row.UnitBuyPrice = 0.0;
				if (compositionRow.RowConfig.Hidden) {
					row.UnitBuyPrice = 0;
				}
				row.Amount = qty;
				row.Duration = compositionRow.Duration;
				row.UnitName = compositionRow.UnitName;
				row.ProductSku = compositionRow.ProductSku;
				row.ReferencedProductID = compositionRow.ReferencedProductID || null;
				row.ReferencedProduct = compositionRow.ReferencedProduct;
				row.UnitBuyPrice = compositionRow.UnitBuyPrice || 0;
				if(compositionRow.ReferencedProduct){
					row.UnitBuyPrice = compositionRow.ReferencedProduct.BuyNettoPrice || 0;
				}
				row.ProductDescription = compositionRow.TranslatedDescription.getTranslationWithoutFallback(this.lng) || compositionRow.ProductDescription;
				row.UnitPrice = compositionRow.UnitPrice;
				row.Discount = compositionRow.Discount;
				row.RowConfig = {...compositionRow.RowConfig};
				toAddRows.push(row);
			}
			return toAddRows;
		}
	},
	created() {
		window.addEventListener("keydown", this.onKeyDown);
	},
	destroyed() {
		window.removeEventListener("keydown", this.onKeyDown);
	},
	components: {
		AppProductEditRow,
		AppProductsTable
	}
});
